import styled from 'styled-components';

export const GhostButton = styled.button`
  background: none
  border: none
`;
